import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjCalendarEmbedRoute: InvariantJiraRoute = {
	name: 'software-plan-calendar-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed',
};
